module.exports = __webpack_public_path__ + "img/ruta.803c172b.jpeg";